class TooltipManager {
  constructor() {
    this.tooltip = null;
    this.currentTarget = null;
    this.observer = null;
    this.boundAutoHide = null;
    this.initTooltip();
    this.initObserver();
    this.initGlobalAutoHide();
  }

  initTooltip() {
    this.tooltip = document.createElement("div");
    this.tooltip.className = "custom-tooltip";
    document.body.appendChild(this.tooltip);
  }

  initObserver() {
    this.observer = new MutationObserver(() => {
      if (this.currentTarget && !document.contains(this.currentTarget)) {
        this.hideTooltip();
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initGlobalAutoHide() {
    this.boundAutoHide = () => this.hideTooltip();
    window.addEventListener("scroll", this.boundAutoHide, true);
    window.addEventListener("resize", this.boundAutoHide, true);
    window.addEventListener("blur", this.boundAutoHide, true);
    document.addEventListener("visibilitychange", this.boundAutoHide, true);
    document.addEventListener("pointerdown", this.boundAutoHide, true);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hideTooltip();
      }
    }, true);
  }

  showTooltip(content, targetElement) {
    this.currentTarget = targetElement;
    this.tooltip.textContent = content;

    const rect = targetElement.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    let top = rect.top - tooltipRect.height - 8;
    let left = rect.left + (rect.width - tooltipRect.width) / 2;

    if (top < 8) {
      top = rect.bottom + 8;
    }

    if (left < 8) {
      left = 8;
    }
    if (left + tooltipRect.width > window.innerWidth - 8) {
      left = window.innerWidth - tooltipRect.width - 8;
    }

    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.top = `${top}px`;

    requestAnimationFrame(() => {
      this.tooltip.classList.add("show");
    });
  }

  hideTooltip() {
    this.currentTarget = null;
    this.tooltip.classList.remove("show");
  }
}

export default new TooltipManager();